import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: -10,
    government: -15,
    office: -15,
  },
  education: {
    childcare: -15,
    high_school: -15,
    library: -5,
    primary: -10,
    university: -5,
  },
  essentials: {
    electricity: 10,
    gas: 15,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 10,
    coffee: 10,
    fast_food: 7,
    restaurant: 10,
  },
  health: {
    clinic: 5,
    dentist: -5,
    hospital: -5,
    pharmacy: 5,
  },
  nature: {
    beach: 10,
    forest: 15,
    lake: 15,
    mountain: 10,
    park: 15,
    river: 15,
  },
  religion: {
    church: 0,
    mosque: 0,
  },
  shops: {
    grocery: 12,
    mall: -5,
  },
  soil: {
    clay: 15,
    loam: 15,
    peat: 15,
    salt: 0,
    sand: 10,
    silt: 15,
  },
  sport: {
    gym: -5,
    pool: -10,
  },
  telecom: {
    cable_tv: -5,
    fiber_optic: 0,
    network_4g: 5,
    network_5g: 5,
    phone: 7,
  },
  transport: {
    airport: -5,
    bus: 10,
    ferry: 5,
    gas_station: 10,
    metro: -5,
    parking: 15,
    taxi: 10,
    train: 5,
    tram: -5,
  },
};

export default PLACES_PROFILE;
